module.exports = __webpack_public_path__ + "images/emoji/mailbox_closed.39dc2644c33037dea7cc.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/mailbox_closed.png
// module id = 0NFA
// module chunks = 1